








































import { Gnfr, GnfrPollutantMeta, Pollutant, TotalEmissionStats } from "@/types";
import Vue, { PropType } from "vue";
import { mapState } from "vuex";
import { fetchGnfrPollutantMetas } from "../services/meta";
import LoadingAnimation from "./LoadingAnimation.vue";

export default Vue.extend({
  props: {
    year: Number,
    gnfr: { type: Object as PropType<Gnfr> },
    pollutant: { type: Object as PropType<Pollutant | undefined> },
    totalEmissionStats: { type: Object as PropType<TotalEmissionStats | undefined> }
  },
  computed: mapState(["lang"]),
  components: {
    LoadingAnimation
  },
  data() {
    return {
      gnfrPollutantMetas: undefined as GnfrPollutantMeta[] | undefined
    };
  },
  methods: {
    getCalcRepShareObject(): GnfrPollutantMeta | undefined {
      if (this.year && this.gnfr && this.pollutant && this.gnfrPollutantMetas) {
        return this.gnfrPollutantMetas.find((o) => {
          return (
            o.year === this.year &&
            o.gnfr === this.gnfr.id &&
            o.pollutant === this.pollutant!.id
          );
        });
      }
      return undefined;
    },
    getRepRatio() {
      const gnfrPollutantShare = this.getCalcRepShareObject();
      if (gnfrPollutantShare) {
        return Math.round(gnfrPollutantShare.repShare * 1000) / 10;
      }
      return "?";
    },
    getCalcRatio() {
      const gnfrPollutantShare = this.getCalcRepShareObject();
      if (gnfrPollutantShare) {
        return Math.round(gnfrPollutantShare.calcShare * 1000) / 10;
      }
      return "?";
    },
    roundTotalEmissions(n: number) {
      const rounded = parseFloat(n.toPrecision(3));
      if (rounded >= 1000) {
        return rounded.toLocaleString("fi-FI", { useGrouping: true });
      }
      return rounded;
    },
    roundPercentage(n: number) {
      // round breakpoint values to at least two significant figures
      for (let i = 1; i < Math.pow(10, 10); i = i * 10) {
        const divider = 10 / i;
        if (n > divider) {
          return Math.round(n * i) / i;
        }
      }
      return n;
    },
    getShareOfGnfrEmissions(tes: TotalEmissionStats) {
      return this.roundPercentage((tes.gnfrEmissions / tes.totalEmissions) * 100);
    }
  },
  async mounted() {
    this.gnfrPollutantMetas = await fetchGnfrPollutantMetas();
  }
});
